module.exports = __webpack_public_path__ + "img/8.5c9fc62a.png";